var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "jaryan-un-authorized-layout h-vh-100 row mx-0" },
    [
      _c("div", { staticClass: "right-side" }, [_vm._t("right")], 2),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "left-side" },
        [
          _c("div", { staticClass: "content" }, [_vm._t("left")], 2),
          _vm._v(" "),
          _vm._t("footer")
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }